import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendContinuousOptimizationCampaign,
  BackendMutationVerifyContinuousOptimizationCampaignArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_CAMPAIGN } from './schema';

const MUTATION = gql`
  mutation VerifyCOCampaign($id: ID!) {
    verifyContinuousOptimizationCampaign(id: $id) {
      ...ContinuousOptimizationCampaign
    }
  }
  ${FRAGMENT_CO_CAMPAIGN}
`;

type Variables = BackendMutationVerifyContinuousOptimizationCampaignArgs;
type Result = Pick<BackendContinuousOptimizationCampaign, 'isScriptVerified'>;

export const verifyCOCampaign = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
